export const NOT_FOUND_RENDER_INCIDENT_TYPE = 'po1';

const NOT_FOUND_RENDER_EVIDENCE_SCHEMA = 'po1/1';

export type NotFoundRenderFigures = {
  readonly requests404: number;
  readonly onDemandRequests: number;
};

export function notFoundRenderFiguresOf(evidence: Record<string, unknown>): NotFoundRenderFigures | null {
  const { requests404, onDemandRequests } = evidence;
  if (evidence.schema !== NOT_FOUND_RENDER_EVIDENCE_SCHEMA) return null;
  if (typeof requests404 !== 'number' || typeof onDemandRequests !== 'number') return null;

  return { requests404, onDemandRequests };
}
